import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './shared/components';
import MainPage from './components/MainPage';
import AboutPage from './components/AboutPage';
import EventsPage from './components/EventsPage';
import MembershipPage from './components/MembershipPage';
import CollaborationPage from './components/CollaborationPage';
import PastEventsPage from './components/PastEventsPage';
import UpcomingEventsPage from './components/UpcomingEventsPage';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/events/past" element={<PastEventsPage />} />
          <Route path="/events/upcoming" element={<UpcomingEventsPage />} />
          <Route path="/membership" element={<MembershipPage />} />
          <Route path="/collaboration" element={<CollaborationPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
